import Tooltip from '../../common/Tooltip'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { useFirestoreGeneralOrderBy } from '../../../firebase/useFirestore'
import NoteBodyCell from '../../notes/NoteBodyCell'
import { db, timestamp } from '../../../firebase/config'
import { v4 as uuid } from 'uuid'
import { client } from '../../../hooks/Client'
import { SavedIcon } from "../../../StateManagment/SavedIcon";
import Location from "../../../hooks/Location"
import { useContext, useState, useEffect } from "react";
import { Auth } from '../../../StateManagment/Auth'
import UserImageMeta from '../../user/UserImageMeta'
import UserNameMeta from '../../user/UserNameMeta'
import DragIndicatorOutlinedIcon from '@mui/icons-material/DragIndicatorOutlined';
import DeleteModal from "../../common/DeleteModal";
import Table from "../../common/table/Table.jsx";
import TableCell from "../../common/table/TableCell.jsx";
import TableTitleCell from "../../common/table/TableTitleCell.jsx";
import ReadOnlyGuard from "../../common/ReadOnlyGuard";
import softDeleteDoc from "../../../helpers/softDeleteDoc";
import ExportBar from "../../common/ExportBar";
import buildNotesExportRows, { NOTES_EXPORT_HEADER } from "../../../helpers/export/buildNotesExportRows";
import downloadDatedExport from "../../../helpers/export/downloadDatedExport";
import filterExportRows from "../../../helpers/export/filterExportRows";
import getSubmitterName from "../../../helpers/getSubmitterName";
import { useFirestoreUsers } from "../../../firebase/useFirestore";

const Notes = ({adressNavigation}) => {
    // Context
   const [saved, setSaved] = useContext(SavedIcon)
    const [auth] = useContext(Auth)

    // State
    const [dragArray, setDragArray] = useState([]);
    const [exportMessage, setExportMessage] = useState('')
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteName, setDeleteName] = useState('dit rapport')
    const [deleteDocid, setDeleteDocid] = useState('')

   // Hooks
   const adressId = Location()[3]
   const options = { year: 'numeric', month: 'numeric', day: 'numeric' };

   // Firestore
   const users = useFirestoreUsers()
   const notes = useFirestoreGeneralOrderBy('AdressNotes', 'AdressID', adressId ? adressId : '', 'Position', 'desc')

   // Whenever Firestore data changes, update dragArray state
    useEffect(() => {
        setDragArray(notes);
    }, [notes]);

    // DRAG & DROP: reorder items and update Firestore
    const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(dragArray);
    const [movedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, movedItem);

    // Update local state to reflect the reorder immediately
    setDragArray(items);

    // Now update Firestore with new positions
    items.forEach((dragArray, idx) => {
        db.collection('AdressNotes')
        .doc(dragArray.docid) // assuming .docid is stored for each doc
        .update({ Position: idx + 1 });
    });

    // Show "saved" icon
        setSaved('flex');
    };

    // Add new note
   const addNote = async () => {

    const noteId = uuid()
    const position = notes.length + 1

       await db.collection('AdressNotes')
       .add({
           ID: noteId,
           AdressID: adressId,
           Title: 'Nieuwe notitie' + ' ' + position,
           Description: '',
           Tags: [],
           CompagnyID: client,
           Compagny: client,
           Position: position,
           Timestamp: timestamp,
           User: auth.ID,
           Body: '',
       })

   }

   // Delete modal 
   const deleteModalHandler = (e) => {
    const docid = e.currentTarget.dataset.docid
    const deleteName = e.currentTarget.dataset.deletename

    setDeleteDocid(docid)
    setDeleteName(deleteName)

    setDeleteModal(!deleteModal)
}

    // Export — het venster kiest wát er mee moet, dit bouwt de rijen.
   const exportHandler = (selection) => {
       const rows = filterExportRows(notes, selection, {
           getId: (note) => note.docid,
           getDate: (note) => (note?.Timestamp?.toDate ? note.Timestamp.toDate() : null),
       })

       const written = downloadDatedExport(
           buildNotesExportRows(rows, { getAuthor: (id) => getSubmitterName(id, users) }),
           { prefix: 'Notities', format: selection.format, header: NOTES_EXPORT_HEADER }
       )

       if (!written) setExportMessage('Geen notities gevonden voor deze keuze.')
       else setExportMessage('')
   }

    // Delete note — zacht verwijderen (ADR-008), zodat een misklik
    // terug te halen is via de prullenbak.
   const deleteNote = async () => {

       await softDeleteDoc({ collection: 'AdressNotes', docid: deleteDocid, authId: auth?.ID })

       setSaved('flex')

   }

  return (
    <div style={{display: adressNavigation === 'notes' ? 'block' : 'none'}}>
         <div  className="persona-option-container">
            <div className='table-container'>
                <ReadOnlyGuard edit="addresses.edit">
                    {(canEdit) => (
                        <Table
                            columns={[
                                { key: 'drag', label: '', searchable: false },
                                { key: 'title', label: 'TITEL' },
                                { key: 'date', label: 'DATUM', searchable: false },
                                { key: 'author', label: 'AUTEUR', searchable: false },
                                { key: 'body', label: 'INHOUD', searchable: false },
                                { key: 'delete', label: 'VERWIJDEREN', searchable: false },
                            ]}
                            items={dragArray || []}
                            getItemKey={(note) => note.ID}
                            renderRow={(note) => (
                                <>
                                    <TableCell>
                                        <DragIndicatorOutlinedIcon />
                                    </TableCell>
                                    <TableTitleCell
                                        value={note.Title}
                                        placeholder="Nieuwe notitie"
                                        to={`/${client}/adressnotedetail/${adressId}/${note.ID}`}
                                        readOnly
                                    />
                                    <TableCell>
                                        {note.Timestamp.toDate().toLocaleDateString("nl-NL", options)}
                                    </TableCell>
                                    <TableCell>
                                        <div id='report-user-meta-container'>
                                            <UserImageMeta userID={note.User} />
                                            <UserNameMeta userID={note.User} />
                                        </div>
                                    </TableCell>
                                    <TableCell>
                                        <NoteBodyCell body={note.Body} />
                                    </TableCell>
                                    <TableCell>
                                        {canEdit && (
                                            <Tooltip content={'Notitie verwijderen'} top='-60px' width={'30px'}>
                                                <DeleteOutlinedIcon className='table-delete-icon' data-id={note.ID} data-docid={note.docid} data-deletename={note.Title} onClick={deleteModalHandler} />
                                            </Tooltip>
                                        )}
                                    </TableCell>
                                </>
                            )}
                            searchAccessor={(note) => note?.Title || ''}
                            searchPlaceholder="Zoeken op titel"
                            emptyMessage="Geen notities gevonden."
                            draggable
                            droppableId="adress-notes"
                            onDragEnd={handleDragEnd}
                            addRow={canEdit ? {
                                toolTipContent: 'Notitie toevoegen',
                                onClick: addNote,
                            } : undefined}
                        />
                    )}
                </ReadOnlyGuard>
                <ExportBar
                    pageHeader='Notities exporteren'
                    itemsLabel='Notities'
                    items={(notes || []).map((note) => ({ id: note.docid, label: note.Title || '(geen titel)' }))}
                    onExport={exportHandler}
                    emptyMessage='Geen notities gevonden.'
                />
                {exportMessage && <p className='dashboard-export-message' role='alert'>{exportMessage}</p>}
                <DeleteModal deleteModal={deleteModal} setDeleteModal={setDeleteModal} deleteItem={deleteNote} deleteName={deleteName} softDelete />
            </div>
        </div>
    </div>
  )
}

export default Notes
